<template>
  <div>
    <h3 class="modal-title"> ADVANCE FORM TABLE </h3>
    <b-form-group :class="{'error-input' : $v.data_bakti_table.title.$error}">
      <label> Advanced Form Table Title </label>
      <j-input
        v-model="$v.data_bakti_table.title.$model"
        :max-length="255"
        placeholder="Table Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_bakti_table.form.$error}">
      <label> Select Form </label>
      <j-single-select
        v-model="$v.data_bakti_table.form.$model"
        :load-options="loadOptionsForm"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Choose Form'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeTable">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveTable">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_bakti_table: {
      title: {
        required,
      },
      form: {
        required,
      },
    },
  },
  data() {
    return {
      data_bakti_table: {
        title: '',
        form: null,
      },
    };
  },
  computed: {
    generateDataBaktiTable() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_bakti_table.form.id,
        }),
        value_id: `${this.data_bakti_table.form.id}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_bakti_table.title,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },

    generateDataBaktiTableUpdate() {
      const data = {
        info: JSON.stringify({
          form_id: this.data_bakti_table.form.id,
        }),
        value_id: `${this.data_bakti_table.form.id}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_bakti_table.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },
  },
  async mounted() {
    if (this.modeEdit) {
      const formDetail = await this.getDetailForm({
        additional_info_block: {
          id: Number(JSON.parse(this.dataEdit.info).form_id),
        },
      });
      this.data_bakti_table.form = {
        id: formDetail.id,
        name: formDetail.name,
        label: formDetail.name,
      };

      this.data_bakti_table.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm']),

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    saveTable() {
      this.$v.data_bakti_table.$touch();
      if (!this.$v.data_bakti_table.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataBaktiTable,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataBaktiTableUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeTable();
      }
    },

    closeTable() {
      this.$emit('close-field');
      this.data_bakti_table.title = '';
      this.data_bakti_table.form = null;
      setTimeout(() => {
        this.$v.data_bakti_table.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jBaktiTableSetup.vue